module.exports = __webpack_public_path__ + "static/img/74HC08-1.4841285.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/74HC08-1.svg
// module id = 0K0O
// module chunks = 0